import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
const steps = ['Before undergoing the procedure at Be CLINICAL, you will have a consultation with one of our qualified providers to discuss your skincare concerns, medical history and treatment goals.', 'During this consultation, we will determine if you are a suitable candidate for the treatment and develop a customized treatment plan tailored to your needs.', 'On the day of the treatment, your skin will be cleansed and a topical numbing cream may be applied to minimize discomfort during the procedure.', 'Protective eyewear will also be provided to shield your eyes from the laser light.', 'The laser device will be passed over the targeted areas of your skin, delivering precise pulses of laser energy. The device combines ablative and non-ablative wavelengths to address both superficial and deeper skin concerns.', 'You may experience a warming or tingling sensation during the procedure, but the topical numbing cream helps minimize any discomfort.', 'After the treatment session is complete, your skin may appear red or swollen, similar to a sunburn.', "It's essential to follow your post-treatment instructions carefully, which may include avoiding sun exposure and using gentle skincare products."];
export function HLTreatment() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1436">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1437">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1438">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-1439">
            WHAT HAPPENS DURING A HALO LASER TREATMENT
          </h2>

          <p className="text-[#333333] text-[17px] leading-[1.7] font-body max-w-[700px] mb-6" data-id="element-1440">
            The treatment process for hybrid fractional laser technology
            typically involves the following steps:
          </p>

          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-1441"></div>
        </AnimateOnScroll>

        <div className="max-w-[800px] mx-auto" data-id="element-1442">
          <div className="relative" data-id="element-1443">
            {/* Vertical line */}
            <div className="absolute left-5 top-5 bottom-5 w-[2px] bg-[#FF1493]/30 hidden lg:block" data-id="element-1444"></div>

            <div className="space-y-8" data-id="element-1445">
              {steps.map((step, index) => <AnimateOnScroll key={index} delay={index * 60} data-id="element-1446">
                  <div className="flex items-start gap-6" data-id="element-1447">
                    <div className="w-10 h-10 rounded-full bg-[#FF1493] flex items-center justify-center flex-shrink-0 relative z-10" data-id="element-1448">
                      <span className="text-white text-sm font-bold font-[Poppins,_sans-serif]" data-id="element-1449">
                        {index + 1}
                      </span>
                    </div>
                    <p className="text-black text-base leading-[1.7] font-body pt-2" data-id="element-1450">
                      {step}
                    </p>
                  </div>
                </AnimateOnScroll>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}